var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10913",
    "data-name": "Group 10913",
    transform: "translate(8547 -21091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10742",
    "data-name": "Group 10742",
    transform: "translate(3352.356 7429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9112",
    "data-name": "Rectangle 9112",
    transform: "translate(-11899.356 13662)",
    fill: "#fff",
    stroke: "#b7deff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10740",
    "data-name": "Group 10740",
    transform: "translate(-16420.234 -8719.506) rotate(-45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1533",
    "data-name": "Line 1533",
    y2: 13.128,
    transform: "translate(-12634.012 19038.016) rotate(-45)",
    fill: "none",
    stroke: "#3070c7",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1534",
    "data-name": "Line 1534",
    y2: 13.128,
    transform: "translate(-12624.729 19038.016) rotate(45)",
    fill: "none",
    stroke: "#3070c7",
    strokeLinecap: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusNew);
export default __webpack_public_path__ + "static/media/Plus New.1a2c2a81a421c6b86727efddc23e7f6a.svg";
export { ForwardRef as ReactComponent };